@if (CompanyId) {
  <div class="container-fluid pb-3">
    <div class="row">
      <div class="col">
        <h2 class="mb-3">Add a site</h2>
      </div>
    </div>
    <div class="row">
      <app-add-edit-site [CompanyId]="CompanyId"></app-add-edit-site>
    </div>
  </div>
}
